import type { FC } from "react"

import { EmployeeAccess, RestrictedAccess, type RestrictedAccessProps, StudentAccess } from "../ui"
import type { IUserInfo } from "~/domain/user-session"

/**
 * Оборачивает компонент в {@link RestrictedAccess}
 * @hoc
 * @category Hocs
 */
export function withRestrictedAccess({ userType, ...props }: RestrictedAccessProps & {
	userType?: IUserInfo["userType"]
} = {}) {

	let RestrictedAccessComponent = RestrictedAccess

	if (userType) {
		if (userType === "обучающийся") RestrictedAccessComponent = StudentAccess
		else if (userType === "сотрудник") RestrictedAccessComponent = EmployeeAccess
	}

	return (Page: FC) => {
		function RestrictedPage() {
			return (
				<RestrictedAccessComponent {...props}>
					<Page />
				</RestrictedAccessComponent>
			)
		}

		RestrictedPage.displayName = Page.displayName ?? Page.name

		return RestrictedPage
	}
}
